import { useEffect } from 'react'

export default function useOnClickOutside(targetRef, handler) {
  useEffect(() => {
    const listener = event => {
      if (!targetRef.current) return
      if (targetRef.current.contains(event.target)) return
      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [targetRef, handler])
}
